import axios from 'axios'
import { useMemo } from 'react'
import useSWR from 'swr'

export default function useRequest(request, { initialData, ...config } = {}) {
  const methodType = request.method === undefined ? 'POST' : request.method   
  const fetcher = () =>  axios({
    ...request,
    method: methodType,  
    withCredentials: request.withCredentials === true
  }).then((response) => response.data)

  const stableData = useMemo(() => request.data, [JSON.stringify(request.data)])
  const swrKey = request?.url ? [request.url, methodType, JSON.stringify(stableData)] : null

  return useSWR(
    swrKey,
    fetcher,
    {
      ...config,
      // refreshInterval: 0,
      // shouldRetryOnError: false,
      dedupingInterval: 1000 * 60 * 60 * 2, // 2hrs nothing is reloaded till refreshed
      focusThrottleInterval: 1000 * 60 * 60 * 2, // 2hrs nothing is reloaded till refreshed
      initialData: initialData,
      revalidateOnFocus: false,
      revalidateOnReconnect: false 
    }
  )
}
